import React from 'react'

const Flag = ({ image, isSelected,lingua, ...props }) => (
  <div className="containerFlag">
  <img alt="flag" src={image} className={isSelected ? 'flag selected' : 'flag'} {...props} />
  </div>
)

export default Flag